import type { IconName } from './components/icons'

export interface NavItem {
  label: string
  icon: IconName
  path: string
  /** Red count pill. Server-driven once wired. */
  badge?: number
  /** Draw a separator above this item (account menu only). */
  rule?: boolean
}

/**
 * Account menu under the sidebar user block.
 *
 * Paths are declared, never derived from the label. The previous version built
 * them with `label.toLowerCase().replace(...)`, which produced routes that were
 * never registered — every item in this menu 404'd.
 */
export const ACCOUNT_NAV: NavItem[] = [
  { label: 'My Profile', icon: 'profile', path: '/profile' },
  { label: 'Account Settings', icon: 'settings', path: '/settings' },
  { label: 'Team & Permissions', icon: 'team', path: '/team-permissions' },
  { label: 'Company Profile', icon: 'company', path: '/company-profile' },
  { label: 'Notification Center', icon: 'bell', path: '/notifications', rule: true },
  { label: 'Help & Support', icon: 'help', path: '/help' },
]

/** Single source for the sidebar and the route table, so they cannot drift. */
export const NAV: NavItem[] = [
  { label: 'Home', icon: 'home', path: '/' },
  { label: 'Search', icon: 'search', path: '/search' },
  { label: 'Role Pipelines', icon: 'pipelines', path: '/pipelines' },
  { label: 'Saved Searches', icon: 'saved', path: '/saved-searches' },
  { label: 'Recommended Executives', icon: 'recommended', path: '/recommended' },
  { label: 'Conversations', icon: 'conversations', path: '/conversations', badge: 6 },
  { label: 'Interviews', icon: 'interviews', path: '/interviews', badge: 3 },
  { label: 'Decision Documentation', icon: 'documentation', path: '/decision-documentation', badge: 2 },
  { label: 'Team Activity', icon: 'team', path: '/team-activity' },
  { label: 'Company Trust Profile', icon: 'trust', path: '/trust-profile' },
  { label: 'Billing & Savings', icon: 'billing', path: '/billing' },
  { label: 'Settings', icon: 'settings', path: '/settings' },
]
